import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { ProductsOfMonthFields } from '../helpers';

export const useProductFormValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  return {
    [ProductsOfMonthFields.PRODUCT_ID]: [requiredRule],
    [ProductsOfMonthFields.PUBLISHED]: [requiredRule],
    [ProductsOfMonthFields.DATE_FROM]: [requiredRule],
    [ProductsOfMonthFields.DATE_TO]: [requiredRule],
  };
};
